export default "__VITE_ASSET__CsFU6Yan__"